import { Icon } from './icons';

interface Props {
  /** Show the dev-mode pill when on a Clerk test key. */
  dev?: boolean;
}

export function Footer({ dev = false }: Props) {
  return (
    <footer className="gw-footer">
      <div className="container gw-footer__inner">
        <Icon.Shield style={{ color: 'var(--vps-blue-400)' }} />
        <span>
          Your prompts never leave your machine.{' '}
          <a href="/" onClick={(e) => e.preventDefault()}>See how →</a>
        </span>
        <div style={{ flex: 1 }} />
        <span>
          © 2026{' '}
          <a href="https://vibeprosoft.com" target="_blank" rel="noreferrer">
            VibeProSoft
          </a>
        </span>
        {dev && (
          <span className="pill pill-amber" style={{ marginLeft: 4 }}>
            <span className="dot" />
            Dev mode
          </span>
        )}
      </div>
    </footer>
  );
}
